export const TYPE_VARIANTS = ["Subscription Plan upgrade", "Bug Report", "Issue", "Help", "I have an idea!"];
export const SUBJECTS = [
    'Bug report',
    'Issue',
    'Help',
    'I have an idea!'
];